import { useMemo } from 'react';
import { useAutomationsSelector } from 'pages/AutomationEngine/store/react';
import { getAutomationIntializationVariables } from 'pages/AutomationEngine/store/selectors';
import { VariableOption } from 'pages/AutomationEngine/types/common';

export const useNumbersVariables = () => {
  const automationVariablesForMergeFields: VariableOption[] =
    useAutomationsSelector(getAutomationIntializationVariables);

  return useMemo(
    () =>
      automationVariablesForMergeFields
        .filter(
          (option) => option.meta.dataType === 'number' && !option.meta.isArray
        )
        .map((option) => ({ ...option, isVariable: true })),
    [automationVariablesForMergeFields]
  );
};
